import { createContext, useContext, useState } from 'react';

import { NotesPanel, ShowNotesOptions } from '../Partials';
import { useScanEditingContext } from './index';

type ShowNotesContextType = {
  showNotesOptions: ShowNotesOptions | undefined;
  showNotesEditor: (options: ShowNotesOptions | undefined) => void;
};

const ShowNotesContext = createContext<ShowNotesContextType | null>(null);

export const useShowNotes = () => {
  const context = useContext(ShowNotesContext);
  if (!context) {
    return {
      showNotesOptions: undefined,
      showNotesEditor: () => {
        throw new Error('useShowNotes must be used within a ShowNotesProvider');
      },
    };
  }
  return context;
};

export const ShowNotesProvider = ({ children }: { children: React.ReactNode }) => {
  const [showNotesOptions, showNotesEditor] = useState<ShowNotesOptions | undefined>(undefined);
  const { scan, scanRoot, scanMutators } = useScanEditingContext();

  return (
    <ShowNotesContext.Provider value={{ showNotesOptions, showNotesEditor }}>
      {children}
      {showNotesOptions && scan && scanRoot && (
        <NotesPanel
          {...showNotesOptions}
          scanRoot={scanRoot}
          scanMutators={scanMutators}
          scan={scan}
          open={!!showNotesOptions}
          flyOutClosed={() => showNotesEditor(undefined)}
        />
      )}
    </ShowNotesContext.Provider>
  );
};
